import { CommonScriptComponent } from './../common-script/common-script.component';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mobile-app-dev',
  templateUrl: './mobile-app-dev.component.html',
  styleUrls: ['./mobile-app-dev.component.css']
})
export class MobileAppDevComponent implements OnInit {

  constructor(private commonScriptComponent:CommonScriptComponent) { }

  ngOnInit() {
    this.commonScriptComponent.onLoad();
  }

}



// WEBPACK FOOTER //
// D:/Projects/Veepal/Veepal.Com/Dev/src/app/mobile-app-dev/mobile-app-dev.component.ts